// extracted by mini-css-extract-plugin
export default {"form":"Subscription_form__bpTUv","inputContainer":"Subscription_inputContainer__0pSQH","input":"Subscription_input__0l1HH","btn":"Subscription_btn__OAPFs"};